/* Crawford Wellness · landing page behaviour
   - option picker: keeps every add-to-cart link and price in sync with the selected option
   - sticky mobile buy bar: appears once the hero CTA scrolls out of view, hides over the offer (scroll listener, no IntersectionObserver)
   - video facade: loads the YouTube iframe only on click
   - option picker "is-selected" class for browsers without :has()
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-lp]').forEach(initPage);
  });

  function initPage(root) {
    /* ---------- option picker ---------- */
    var radios = root.querySelectorAll('input[name="lp-option"]');
    var atcLinks = root.querySelectorAll('[data-lp-atc]');
    var priceOuts = root.querySelectorAll('[data-lp-price]');
    var titleOuts = root.querySelectorAll('[data-lp-title]');

    function applySelection() {
      var sel = root.querySelector('input[name="lp-option"]:checked');
      radios.forEach(function (r) {
        var opt = r.closest('.lp-opt');
        if (opt) opt.classList.toggle('is-selected', r.checked);
      });
      if (!sel) return;
      var href = sel.getAttribute('data-href');
      var price = sel.getAttribute('data-price') || '';
      var title = sel.getAttribute('data-title') || '';
      atcLinks.forEach(function (a) { if (href) a.setAttribute('href', href); });
      priceOuts.forEach(function (el) { el.textContent = price; });
      titleOuts.forEach(function (el) { el.textContent = title; });
    }
    radios.forEach(function (r) { r.addEventListener('change', applySelection); });
    applySelection();

    /* ---------- sticky bar ---------- */
    var sticky = root.querySelector('[data-lp-sticky]');
    var heroCta = root.querySelector('[data-lp-hero-cta]');
    var offer = root.querySelector('[data-lp-offer]');
    if (sticky && heroCta) {
      var pending = false;
      var update = function () {
        pending = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var heroGone = heroCta.getBoundingClientRect().bottom < 0;
        var offerInView = false;
        if (offer) {
          var r = offer.getBoundingClientRect();
          offerInView = r.top < vh * 0.85 && r.bottom > vh * 0.15;
        }
        sticky.classList.toggle('is-visible', heroGone && !offerInView);
      };
      var schedule = function () { if (!pending) { pending = true; setTimeout(update, 80); } };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    }

    /* ---------- video facade ---------- */
    root.querySelectorAll('[data-lp-video]').forEach(function (box) {
      var btn = box.querySelector('.lp-video__btn');
      var id = box.getAttribute('data-lp-video');
      if (!btn || !id) return;
      btn.addEventListener('click', function () {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1');
        iframe.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        box.innerHTML = '';
        box.appendChild(iframe);
      });
    });
  }
})();
